import { Value } from '../../types';
import { HttpMethod,  RequestOptions } from '../http-service';

import DefaultFileHandler, { EventsRequest } from './default-file-handler';
import { FileHandler, FileInterface, RemoveCallback } from './file-handler-configuration';

class FileService {
  private fileHandler!: FileHandler;

  constructor() {
    this.fileHandler = new DefaultFileHandler();
  }

  download(endpoint: string, name?: string, parameters?: Record<string, Value>, method?: HttpMethod, options?: RequestOptions): Promise<Blob> {
    return this.fileHandler.download(endpoint, name, parameters, method, options);
  }

  preview(path: string): void {
    this.fileHandler.preview(path);
  }

  upload(file: File, events: EventsRequest): Promise<FileInterface> {
    return this.fileHandler.upload(file, events);
  }

  remove(path: string, name: string, onExecuteRemove: RemoveCallback): void {
    this.fileHandler.remove(path, name, onExecuteRemove);
  }

  setFileHandler(fileHandler: FileHandler): void {
    this.fileHandler = fileHandler;
  }
}

const instance = new FileService();

export default instance;
